var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeartPurpleinline = function SvgHeartPurpleinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.806.707a2.366 2.366 0 0 0-.768-.523 2.33 2.33 0 0 0-2.582.523L5 1.172 4.543.707A2.346 2.346 0 0 0 2.87 0C2.24 0 1.638.255 1.194.707A2.438 2.438 0 0 0 .5 2.414c0 .64.25 1.254.694 1.707l.456.465L5 8l3.35-3.414.456-.465c.22-.224.395-.49.514-.783a2.453 2.453 0 0 0-.514-2.63Z",
    fill: "#7D64FF"
  })));
};
export default SvgHeartPurpleinline;